
export default {
  name: 'BbPopover',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: 'top',
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    htmlContent: {
      type: String,
      default: '',
    },
    container: {
      type: [String, Boolean],
      default: '',
    },
    hideOnOutsideClick: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '267px',
    },
    offset: {
      type: String,
      default: '8',
    },
    titleColor: {
      type: String,
      default: 'inherit',
    },
    popoverClass: String,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onUpdate($event) {
      this.$emit('input', $event);
    },
  },
  computed: {
    computedProps() {
      const extraProps = {};

      if (typeof this.container === 'boolean' || this.container) {
        Object.assign(extraProps, {
          container: this.container,
        });
      }

      return {
        open: this.value,
        disabled: this.isDisabled,
        placement: this.alignment,
        autoHide: this.hideOnOutsideClick,
        offset: this.offset,
        popoverBaseClass: ['bb-popover', this.popoverClass ? this.popoverClass : ''],
        ...extraProps,
      };
    },
    computedPopoverStyle() {
      return {
        width: this.width,
      };
    },
    computedTitleStyles() {
      return {
        color: this.titleColor,
      };
    },
  },
};
